import { render, staticRenderFns } from "./LevelData.vue?vue&type=template&id=0ec65d3a&scoped=true&"
import script from "./LevelData.vue?vue&type=script&lang=ts&"
export * from "./LevelData.vue?vue&type=script&lang=ts&"
import style0 from "./LevelData.vue?vue&type=style&index=0&id=0ec65d3a&scoped=true&lang=css&"
import style1 from "./LevelData.vue?vue&type=style&index=1&id=0ec65d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec65d3a",
  null
  
)

export default component.exports